import { render, staticRenderFns } from "./ImportExcel.vue?vue&type=template&id=af320054&scoped=true&"
import script from "./ImportExcel.vue?vue&type=script&lang=js&"
export * from "./ImportExcel.vue?vue&type=script&lang=js&"
import style0 from "./ImportExcel.vue?vue&type=style&index=0&id=af320054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af320054",
  null
  
)

export default component.exports